import script from "./PexCollectionAssetTableNext.vue?vue&type=script&setup=true&lang=js"
export * from "./PexCollectionAssetTableNext.vue?vue&type=script&setup=true&lang=js"

import "./PexCollectionAssetTableNext.vue?vue&type=style&index=0&id=420a17ca&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420a17ca"]])

export default __exports__